import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  baseContactData,
  buildLocationData,
  socialContactData,
} from "../data/contact";

interface ContactInfoProps {
  variant?: "light" | "dark";
  className?: string;
  location?: string;
}

const ContactInfo: React.FC<ContactInfoProps> = ({ variant = "light", location }) => {
  const locationData = buildLocationData(location);

  const contactData = [...baseContactData, ...locationData, ...socialContactData];

  const isDark = variant === "dark";

  return (
    <address className="not-italic">
      <div className="contact-info-grid md:mb-0 mb-20">
        {contactData.map((contact, index) => (
          <div
            key={contact.label}
            className={`contact-item ${
              isDark ? "contact-item-dark" : "contact-item-light"
            }`}
            style={{ animationDelay: `${index * 0.1}s` }}
          >
            <div className="contact-icon-wrapper" aria-hidden="true">
              <FontAwesomeIcon icon={contact.icon} className="contact-icon" />
            </div>
            <div
              className="contact-details contact-details-label-left"
              style={{ justifyContent: "flex-start", textAlign: "left" }}
            >
              <span
                className="contact-label"
                style={{
                  marginRight: "0.5em",
                  minWidth: "80px",
                  display: "inline-block",
                  textAlign: "left",
                  justifyContent: "flex-start",
                }}
              >
                {contact.label}
              </span>
              {contact.href ? (
                <a
                  href={contact.href}
                  target={
                    contact.href.startsWith("http") ? "_blank" : undefined
                  }
                  rel={
                    contact.href.startsWith("http")
                      ? "noopener noreferrer"
                      : undefined
                  }
                  className="contact-value contact-link"
                  style={{
                    textAlign: "left",
                    display: "inline-block",
                  }}
                >
                  {contact.value}
                </a>
              ) : (
                <span
                  className="contact-value"
                  style={{
                    textAlign: "left",
                    display: "inline-block",
                  }}
                >
                  {contact.value}
                </span>
              )}
            </div>
          </div>
        ))}
      </div>
    </address>
  );
};

export default ContactInfo;
